import React from 'react';
import LibPagination from "react-js-pagination";

import style from './style.module.less';

export const Pagination = ({
  disabled,
  activePage,
  itemsCountPerPage,
  totalItemsCount,
  pageRangeDisplayed,
  onChange,
}) => 
  <div className={`${style.paginationContainer} d-flex justify-content-center`} role="group" aria-disabled={disabled}>
    <LibPagination
      activePage={activePage}
      itemsCountPerPage={itemsCountPerPage}
      totalItemsCount={totalItemsCount}
      pageRangeDisplayed={pageRangeDisplayed}
      onChange={onChange}
      itemClass="page-item"
      linkClass="page-link"
    />
  </div>
